import { render, staticRenderFns } from "./RelatorioPagamentosGeral.vue?vue&type=template&id=5124dd38&scoped=true"
import script from "./RelatorioPagamentosGeral.vue?vue&type=script&lang=js"
export * from "./RelatorioPagamentosGeral.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPagamentosGeral.vue?vue&type=style&index=0&id=5124dd38&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124dd38",
  null
  
)

export default component.exports